<template>
  <PositionDialogs
    :value="value"
    center
    title="Activate Position"
    :message="message"
    icon="org_icon_position"
    buttonType="magenta"
    actionLabel="Activate"
    @input="emit('input', $event)"
    @onAction="emit('onAction')"
    @onClose="emit('onClose')"
  />
</template>

<script setup>
import { computed } from "vue";
import PositionDialogs from "@components/PositionDialogs/PositionDialogs.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: "<position name>"
  }
});

const emit = defineEmits(["input", "onAction", "onClose"]);

const message = computed(() => {
  return `Position ${props.name} is about to be activated.\nThis is irreversible. Once you activate, you cannot move back the position in status Draft.`;
});
</script>
